module.exports = "/_next/static/images/Eric-85ccb74da5d593df5584ba0582e14de2.jpg";